import View from './IPAllowlist.view';

export default View;
